<template>
	<div class="prose max-w-none bg-zinc-50 antialiased">
		<DashboardHeader />

		<slot />

		<DashboardFooter class="mt-8" />
	</div>
</template>

<script setup>
import DashboardHeader from '@/components/headers/DashboardHeader.vue'
import DashboardFooter from '@/components/footers/DashboardFooter.vue'

/*******
 * Layout settings
 *
 * To disable the footer per page, use definePageMeta({layoutSettings: {showFooter: false}})
 * To disable the menu per page, use definePageMeta({layoutSettings: {showMenu: false}})
 *
 *******/

// we need to call this here to trigger the hydration of the carbar-Au-Auth-Store within the initial setups, otherwise
// we get an "onUnmounted" warning from pinia's persisted state. See DE-5187
isLoggedIn()
checkAuthLoginVersion()

const route = useRoute()

onBeforeMount(() => {
	useRecaptcha()
})

const pageMeta = siteMeta(route.path)

if (!route.meta.disableGenericCanonical) {
	useHead(() => ({
		// Tile and meta description needs to be declared here, it acts
		// as a fallback for other pages to avoid displaying undefined
		// value in title and meta tag due to reactivity for certain pages ie. vehicle page.
		// Meta values are set in utils siteMeta.js
		title: pageMeta?.title,
		meta: [
			{
				name: 'description',
				content: pageMeta?.description,
			},
			{
				name: 'keywords',
				content: pageMeta?.keywords,
			},
		],
		link: [
			{
				rel: 'canonical',
				href: pageMeta?.url,
			},
		],
		htmlAttrs: {
			lang: pageMeta?.locale,
		},
	}))

	if (import.meta.server) {
		useSeoMeta({
			ogType: pageMeta?.type,
			ogTitle: pageMeta?.title,
			ogUrl: pageMeta?.url,
			ogDescription: pageMeta?.description,
			ogImage: pageMeta?.image,
			ogImageWidth: pageMeta?.imageWidth,
			ogImageHeight: pageMeta?.imageHeight,
			ogLocale: pageMeta?.locale,
			twitterCard: 'summary_large_image',
			twitterSite: '@carbarcomau',
			twitterTitle: pageMeta?.title,
			twitterDescription: pageMeta?.description,
			twitterImage: pageMeta?.image,
		})
	}
}
</script>
